"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FineTuningResponse = void 0;
const core = __importStar(require("../../core"));
const FineTuningResponseModelStateValue_1 = require("./FineTuningResponseModelStateValue");
const VerificationAttemptResponse_1 = require("./VerificationAttemptResponse");
const ManualVerificationResponse_1 = require("./ManualVerificationResponse");
exports.FineTuningResponse = core.serialization.object({
    isAllowedToFineTune: core.serialization.property("is_allowed_to_fine_tune", core.serialization.boolean().optional()),
    state: core.serialization.record(core.serialization.string(), FineTuningResponseModelStateValue_1.FineTuningResponseModelStateValue).optional(),
    verificationFailures: core.serialization.property("verification_failures", core.serialization.list(core.serialization.string()).optional()),
    verificationAttemptsCount: core.serialization.property("verification_attempts_count", core.serialization.number().optional()),
    manualVerificationRequested: core.serialization.property("manual_verification_requested", core.serialization.boolean().optional()),
    language: core.serialization.string().optional(),
    progress: core.serialization.record(core.serialization.string(), core.serialization.number().optional()).optional(),
    message: core.serialization.record(core.serialization.string(), core.serialization.string().optional()).optional(),
    datasetDurationSeconds: core.serialization.property("dataset_duration_seconds", core.serialization.number().optional()),
    verificationAttempts: core.serialization.property("verification_attempts", core.serialization.list(VerificationAttemptResponse_1.VerificationAttemptResponse).optional()),
    sliceIds: core.serialization.property("slice_ids", core.serialization.list(core.serialization.string()).optional()),
    manualVerification: core.serialization.property("manual_verification", ManualVerificationResponse_1.ManualVerificationResponse.optional()),
    maxVerificationAttempts: core.serialization.property("max_verification_attempts", core.serialization.number().optional()),
    nextMaxVerificationAttemptsResetUnixMs: core.serialization.property("next_max_verification_attempts_reset_unix_ms", core.serialization.number().optional()),
    finetuningState: core.serialization.property("finetuning_state", core.serialization.unknown().optional()),
});
